export const API_FORM_SERVICE_NAME = 'form';
export const API_SET_VALUE_METHOD_NAME = 'setFieldValue';
export const API_SUBMIT_EVENT_NAME = 'submit';

export const API_STATIC_ENDPOINTS_SCHEMA = {
  [API_FORM_SERVICE_NAME]: true
};

export const STRING_TYPES = [
  'shortText',
  'longText',
  'email',
  'phone',
  'URL',
  'hidden'
] as const;

export const EXCLUDED_VALIDATE_FIELD_TYPES = [
  'label',
  'heading',
  'paragraph',
  'hidden',
  'file',
  'slider',
  'signature',
  'calculation'
] as const;

export const EXCLUDED_SUBMIT_FIELD_TYPES = ['label', 'heading', 'paragraph'];
export const FIELDS_WITH_SELECT = ['choice', 'imageChoice', 'dropdown'];
